import React, { useState } from 'react'
import { NumberConvert } from '../../../common/numberConvert'
import Modal from 'react-modal';
import MainItemModal from './MainItemModal';
import { isMobile } from 'react-device-detect';
import dayjs from 'dayjs';

const MainItem = ({ data, buycount, point, setUserPoints, userBuyTotal, setUserBuyTotal }) => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const basicID = window.sessionStorage.getItem('basicID');

  // 모달 온오프 기능
  const [modalOpen, setModalOpen] = useState(false);

  // 모달 안에 데이터 삽입
  const [modalData, setModalData] = useState([]);

  // 이미지 에니메이션
  const [boxMove, setBoxMove] = useState(-1);
  
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 p-1.5 gap-3 text-sm overflow-y-hidden overflow-x-auto duration-200'>
      {data.map((v, i)=>(
        // // 구매 가능한 횟수 체크
        v.buycount > 0
        &&
        <div key={i} className={`
        relative duration-100 flex flex-col gap-3 items-center p-3 bg-[#3E3E3E] rounded-md w-full h-[350px] 
        ${v.state === '정상' && v.count >= 1 && v.price < point ? 'border-[1px] border-blue-500 hover:bg-blue-500/70 active:bg-blue-500/50 hover:scale-[1.03] opacity-90 hover:opacity-100 cursor-pointer' : 'cursor-not-allowed border-[1px] opacity-70 border-red-500/80'}
        `} onMouseEnter={()=>setBoxMove(i + 1)} onMouseLeave={()=>setBoxMove(-1)} onClick={()=>{
          if(v.state === '정상' && v.count >= 1 && v.price < point){
            setModalOpen(true);
            setModalData(v);
          } else {
            setModalData(false);
            setModalData(v);
          }
        }}>

          {/* 재고 및 상태 */}
          {
            v.state === '정상' && v.count >= 1 && v.price < point &&
            <div className='absolute flex justify-between top-0 w-full'>
              <p className='bg-[#2E2E2E]/60 p-2 rounded-md'>
                {
                  (v.value === '정상' && `상태 🟢`) ||
                  (v.value === '비정상' && `상태 🟡`) ||
                  (v.value === '위험' && `상태 🟠`) ||
                  (v.value === '고위험' && `상태 🔴`)
                }
              </p>
              <p className='bg-[#2E2E2E]/60 p-2 rounded-md'>
              {
                (v.count <= 3 && '재고 🔴') ||
                (v.count <= 5 && '재고 🟠') || 
                (v.count <= 10 && '재고 🟡') ||
                (v.count > 10 && '재고 🟢')
              }
              </p>
            </div>
          }

          {/* 이미지 */}
          <div>
            <p className={`text-5xl opacity-80
              ${v.state !== '정상' && 'opacity-30'}
              ${v.no === boxMove && v.state === '정상' && v.count >= 1 && v.price < point && 'animate-bounce'}`}>
              🎁
            </p>
          </div>

          {/* 이름 */}
          <div className='flex flex-col gap-3 p-3'>
            <p className='bg-[#2E2E2E] p-3 rounded-md font-bold tracking-wide'>{v.title}</p>
          </div>

          {/* 🔍🔎 */}
          {/* 제품 설명 */}
          <div className={`${v.no === boxMove && v.state === '정상' && v.count >= 1 && v.price < point ? 'bg-[#2E2E2E] rounded-md' : 'bg-[#4E4E4E] rounded-sm'} w-full text-sm p-3`}>
            <p className=''>
              {v.text.length > 60 ? v.text.substr(0, 60) + '🔎' : v.text}
            </p>
          </div>

          {/* 부가 설명 */}
          <div className={`${v.no === boxMove && v.state === '정상' && v.count >= 1 && v.price < point ? 'bg-[#2E2E2E] rounded-md' : 'bg-[#4E4E4E] rounded-sm'} w-full text-sm p-3`}>
            <p className=''>{v.subtitle}</p>
          </div>
          
          {/* 구매버튼 */}
          <div className={`${v.state === '정상' && v.count >= 1 && v.price < point ? 'bg-blue-500' : 'bg-red-500/80'} flex gap-2 items-center justify-center bottom-0 w-full rounded-b-sm absolute`}>
            {v.state === '정상' && v.count >= 1 && v.price < point ?
              <div className={`py-2 flex items-center justify-center gap-2 w-full tracking-wide duration-100`}>
              
                <p style={{fontFamily: 'Gugi'}} className=''>구매 하기</p>
                <p style={{fontFamily: 'Gugi'}} className=''>|</p>
                <p style={{fontFamily: 'Gugi'}} className=''>{NumberConvert(v.price)} P</p>
                
              </div>
              :
              <div className={`py-2 flex items-center justify-center gap-2 w-full tracking-wide duration-100`}>
                <p style={{fontFamily: 'Gugi'}} className=''>구매 불가 |</p>
                <p style={{fontFamily: 'Gugi'}} className=''>
                  {/* {(v.state !== '정상' ? v.state : v.count === 0 && '재고 없음') */}
                  {(v.state !== '정상' ? v.state : v.count < 1 && '재고 없음') || (v.state !== '정상' ? v.state : v.price > point && '포인트 부족')}
                </p>
              </div>
            }
          </div>

        </div>
      ))}

      {/* 모달 */}
      <div>
        <Modal isOpen={modalOpen} closeTimeoutMS={100} ariaHideApp={false} onRequestClose={()=>setModalOpen(false)} 
        style={
          isMobile ?
          {
          overlay: {
            backgroundColor: 'rgba(30, 30, 30, 0.80)'
          },
          content: {
            background: '#424242',
            border: '2px solid #5E5E5E',
            margin: 'auto',
            overflow: 'auto',
            height: '100%',
            display: 'grid',
            justifyContent: 'center',
            alignItems: 'center',
          }
          }
          :
          {
            overlay: {
              backgroundColor: 'rgba(30, 30, 30, 0.80)'
            },
            content: {
              background: '#424242',
              border: '2px solid #5E5E5E',
              width: '90%',
              maxWidth: '600px',
              height: '700px',
              margin: 'auto',
            }
          }
          }>
            {
            <MainItemModal data={modalData} setModalOpen={setModalOpen} point={point} setUserPoints={setUserPoints} userBuyTotal={userBuyTotal} setUserBuyTotal={setUserBuyTotal} />
            }
        </Modal>
      </div>

    </div>
  )
}

export default MainItem